/* eslint-disable no-restricted-globals */
import { CHECK_EMAIL_REMINDER_PARAM } from "@components/collapsible-header/CollapsibleHeader";
import { setUpid } from "src/utils/redux/slices/upid";
import store from "src/utils/redux/store";
import { isHM } from "src/utils/userSegment";
import { pushReroll, reroll, setParam } from "./utils";

function isEnrollment() {
  return location.pathname.startsWith("/enrollment");
}

function enrollmentBase() {
  return isHM() ? "/enrollment-hm" : "/enrollment";
}

export default {
  enrollment({
    claimedByEmail,
    enrollmentResult,
    showEmailReminder,
    ...params
  }: {
    name: string;
    email: string;
    claimedByEmail?: string;
    planId: string;
    route?: string;
    enrollmentResult?: string;
    showEmailReminder?: boolean;
    upid?: string; // Deprecated
  }) {
    const state = store.getState();
    const languageCode = state.language;
    const countryCode = state.geoLocation.country_code;
    localStorage.setItem(
      "enrollmentData",
      JSON.stringify({
        ...params,
        lc: languageCode,
        cc: countryCode,
      })
    );

    const queryParams = new URLSearchParams();
    // Deprecated -- prefer to use the `upid` Redux state slice instead. This is kept only for
    // back-compat for ESDE flows
    if (params.upid) {
      // Keep the redux store in sync
      store.dispatch(setUpid(params.upid));
      setParam(queryParams, "upid", params.upid);
    }
    setParam(queryParams, "lc", languageCode);
    setParam(queryParams, "cc", countryCode);
    setParam(queryParams, "rerollMerEx", "true");

    const currentQueryParams = new URLSearchParams(location.search);
    setParam(queryParams, "route", currentQueryParams.get("route"));
    setParam(queryParams, "experiment", currentQueryParams.get("experiment"));
    setParam(
      queryParams,
      "claimedByEmail",
      claimedByEmail ?? currentQueryParams.get("claimedByEmail")
    );
    setParam(
      queryParams,
      "enrollmentResult",
      enrollmentResult ?? currentQueryParams.get("enrollmentResult")
    );
    setParam(queryParams, CHECK_EMAIL_REMINDER_PARAM, showEmailReminder);
    reroll(enrollmentBase(), queryParams);
  },
  accountCreated(email: string) {
    pushReroll(
      `${enrollmentBase()}/account-created?email=${encodeURIComponent(email)}`,
      isEnrollment
    );
  },
};
